/*
 * Copyright (c) 2021 by Leyton Group - All Rights Reserved.
 *  This source code, and resulting software, is the confidential and proprietary information
 *  ("Proprietary Information") and is the intellectual property ("Intellectual Property")
 *  of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
 *  and shall use it only in accordance with the terms and conditions of any and all license
 *  agreements you have entered into with The Company.
 */

import axios from "axios";
import { pathConstants } from "../../../shared/pathConstants";
import Vue from "vue";

export const ReportingService = {
  getClientVolumeData,
  getFicheData,
  getBreakingRateData,
  getWorkVolumeReport,
  getWorkVolumeReportAdminAgence,
  getWorkVolumeReportChargeDeProjet,
  getWorkVolumeByStatusReport,
  downloadOperationVolumeByMonth
};

function getClientVolumeData(period, agence) {
  return axios
    .post(pathConstants.API + "/reporting/operation/volume", { period, agence })
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("fetch volume reporting data", err);
      }
    );
}

function getFicheData() {
  return axios.get(pathConstants.API + "/reporting/fiche").then(
    result => {
      return result.data;
    },
    err => {
      Vue.$log.error("fetch fiche reporting data", err);
    }
  );
}

function getBreakingRateData() {
  return axios.get(pathConstants.API + "/reporting/operation/abandon").then(
    result => {
      return result.data;
    },
    err => {
      Vue.$log.error("fetch operation abandon reporting data", err);
    }
  );
}

function getWorkVolumeReport() {
  return axios.get(pathConstants.API + "/reporting/work/volume").then(
    result => {
      return result.data;
    },
    err => {
      Vue.$log.error("fetch work volume dashboard data", err);
    }
  );
}

function getWorkVolumeReportAdminAgence(agenceId) {
  return axios
    .get(pathConstants.API + `/reporting/work/volume/agences/${agenceId}`)
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error(
          "fetch work volume dashboard data for admin agency",
          err
        );
      }
    );
}

function getWorkVolumeReportChargeDeProjet() {
  return axios
    .get(pathConstants.API + "/reporting/work/volume/chargeDeProjets")
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("fetch work volume dashboard data user", err);
      }
    );
}

function getWorkVolumeByStatusReport() {
  return axios.get(pathConstants.API + "/reporting/work/volumeByStatus").then(
    result => {
      return result.data;
    },
    err => {
      Vue.$log.error("fetch work volume by status dashboard data", err);
    }
  );
}

function downloadOperationVolumeByMonth(reportingVolumeDto) {
  return axios
    .post(
      pathConstants.API + "/reporting/operation/volumeByMonth",
      reportingVolumeDto,
      { responseType: "blob" }
    )
    .then(
      result => {
        return result.data;
      },
      err => {
        Vue.$log.error("download operation volume by month dashboard", err);
      }
    );
}
